// Module
var code = "<div class=\"total-application-details\"> <div class=\"total-application-amount\"> Total <span> {{vm.pageTotalAmount | currency:crmCurrency:0}} of {{vm.overallTotalAmount | currency:crmCurrency:0}} ◆ {{vm.itemsPerPage}} of {{vm.totalItems}} </span> </div> </div> ";
// Exports
module.exports = code;